import { Input as UiInput } from "@xola/ui-kit";
import React, { ComponentProps, forwardRef } from "react";
import NumberFormat from "react-number-format";

interface FormatInputProps extends ComponentProps<typeof NumberFormat> {
    isError?: boolean;
    isRequired?: boolean;
    isStyled?: boolean;
}

export const FormatInput = (props: FormatInputProps) => {
    return (
        <NumberFormat<InputProps>
            allowEmptyFormatting
            // @ts-expect-error -- TODO: Resolve the ref incompatibility error
            customInput={Input}
            /** `NumberFormat` does not paas default `suffix` and `prefix` props to customInput component, so we have created custom props for them */
            suffixValue={props.suffix}
            prefixValue={props.prefix}
            {...props}
        />
    );
};

interface InputProps extends ComponentProps<"input"> {
    suffixValue?: string;
    prefixValue?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ suffixValue, prefixValue, ...rest }, ref) => {
    return <UiInput ref={ref} suffix={suffixValue} prefix={prefixValue} {...rest} />;
});
